<template>
        <div class="row headerNavClass" :borderStyle="borderStyle" :registeredDetail="registeredDetail">
         <div class="headerNavImageClass" style="font-size:20px;color:#fff;" >
             <div @click="backIndexHtml" class="imageDiv">
                   <img src="../../../static/img/account/developer-2.png" alt="" class="backIndexImage">
             </div>
        </div>
        <!-- <div class="col-md-9" style="font-size:20px;color:#fff;"> -->
        <div style="font-size:20px;color:#fff;width: 100%;">
            <div class="divAllClass" style="display:flex;margin-left: 6px;" >
                <!-- <span style="display:flex;flex-grow:1;"></span> -->
                <div class="distribute developerAll developerAllShow developerPlan" ref="myDevelopmentPlan" @click="btnBackStyle($event, 'developmentPlan')">{{this.$t('developmentPlan')}}</div>
                <span class="spanBorderClass">|</span>
                <div class="documentation developerAll developerAllShow" ref="myfile" @click="btnBackStyle($event, 'file')">{{this.$t('file')}}</div>
                <span class="spanBorderClass">|</span>
                <a :href="forumUrl" class="support developerAll developerAllShow" ref="mydiscuss" @click="btnBackStyle($event,'discuss')">{{this.$t('discuss')}}</a>
                <!-- <div class="support developerAll developerAllShow" ref="mydiscuss" @click="btnBackStyle($event,'discuss')">{{this.$t('discuss')}}</div> -->
                <span class="spanBorderClass">|</span>
                <div class="blog developerAll developerAllHide" title='暂未开放' @click="btnBackStyle($event, 'blog')">{{this.$t('blog')}}</div>
                <span class="spanBorderClass">|</span>
                <!-- <div style="display:flex;flex-grow:1;"></div> -->
                <span style="display:flex;flex-grow:1;"></span>
                <div @mouseenter="loginMouseenterFunc()" @mouseleave="loginMouseleaveFunc()" class="account developerAll developerAllShow" ref="myLogin" @click="btnBackStyle($event,'login')">
                    <span v-show="!isShowSelect">{{ loginOut }}</span>
                    <img v-show="isShowSelect" style="width: 19px;height: 24px;" src="../../../static/img/header/account_null.png" alt="">
                </div>
                <!-- <span style="font-size:20px;color:red;display:none;">{{borderStyle}}</span> -->
                <!-- <div class="divSearchImage">
                    <input  @focus="inputSearch"  @blur="inputSearchBlur" type="text" class="searchInputClass" v-model="inputContent" :onKeypress="onKeypress">
                    <img @click="inputSearchClick" src="../../../static/img/account/searchImage.png" class="serchImageClass" :style="imgSearch"/>
                </div> -->
            </div>
        </div>
        <div class="rectangle_10"></div>
        <!-- <div style="display:none;">{{registeredDetail}}</div> -->
     </div>
</template>
<script>
    // import config from '../../config'
    export default {
        data () {
            let protocol = window.location.protocol
            let splitLine = '//'
            let env = window.location.hostname
            let path = protocol + splitLine + env
            return {
                imgSearch: '',
                inputContent: '',
                autofocus: true,
                loginOut: '',
                forumUrl: '',
                onKeypress: 'javascript:if(event.keyCode == 32)event.returnValue = false;',
                isShowSelect: false,
                base: path,
                path: '',
                env: env,
                baseUrl: '/developerUser',
                frontPort: '8080'
            }
        },
        methods: {
            loginMouseenterFunc () {
                if (sessionStorage.registeredDetail === 'true') {
                    this.$store.state.isIndexSelectShow = true
                }
            },
            loginMouseleaveFunc () {
                this.$store.state.isIndexSelectShow = false
            },
            btnBackStyle (e, data) {
                let eleItems = document.querySelector('.backgroundStyle')
                let eleItemsStyles = e.currentTarget.classList
                let indexArr = e.currentTarget.classList.contains('backgroundStyle')
                let indexHide = e.currentTarget.classList.contains('developerAllHide')
                if (eleItems && indexArr || indexHide) {
                    return
                } else if (eleItems && !indexArr) {
                    eleItems.classList.remove('backgroundStyle')
                }
                eleItemsStyles.add('backgroundStyle')
                this.jumpFunc(data)
            },
            jumpFunc (data) {
                switch (data) {
                    case 'developmentPlan':
                        this.$store.state.borderStyle = 'developmentPlan'
                        localStorage.setItem('clickState', 'developmentPlan')
                        this.$router.push({name: 'introduces'})
                        break
                    case 'file':
                        this.$store.state.borderStyle = 'file'
                        localStorage.setItem('clickState', 'file')
                        this.$router.push({name: 'listApp'})
                        break
                    case 'discuss':
                        this.$store.state.borderStyle = 'discuss'
                        localStorage.setItem('clickState', 'discuss')
                        // window.location.href = 'https://dss.nuwarobotics.cn/forum/'
                        break
                    case 'blog':
                        break
                    case 'login':
                        if (sessionStorage.registeredDetail === 'true') {
                            this.$refs.myLogin.classList.remove('backgroundStyle')
                            this.styleFunc(this.$store.state.borderStyle)
                            this.env === 'localhost' ? this.path = this.base + ':' + this.frontPort + this.baseUrl + '/myAccount' : this.path = this.base + this.baseUrl + '/myAccount'
                            window.location.href = this.path
                            return
                        } else {
                            this.$store.state.borderStyle = 'login'
                            localStorage.setItem('clickState', 'login')
                            this.env === 'localhost' ? this.path = this.base + ':' + this.frontPort + this.baseUrl + '/login' : this.path = this.base + this.baseUrl + '/login'
                            window.location.href = this.path
                        }
                        break
                    default:
                }
            },
            styleFunc (borderStyle) {
                let eleItems = document.querySelector('.backgroundStyle')
                if (eleItems) eleItems.classList.remove('backgroundStyle')
                switch (borderStyle) {
                    case 'developmentPlan':
                        // console.log('developmentPlan')
                        this.$refs.myDevelopmentPlan.classList.add('backgroundStyle')
                        this.$router.push({name: 'introduces'})
                        break
                    case 'file':
                        this.$refs.myfile.classList.add('backgroundStyle')
                        // 判断是否点击了 footer下面的连接 目的：防止刷新跳转
                        if (sessionStorage.cliclkFile === 'true' || sessionStorage.isSideBarShow !== 'null') {
                            return
                        }
                        // console.log('in')
                        this.$router.push({name: 'listApp'})
                        break
                    case 'discuss':
                        this.$refs.mydiscuss.classList.add('backgroundStyle')
                        this.$store.state.borderStyle = 'discuss'
                        localStorage.setItem('clickState', 'discuss')
                        break
                    case 'blog':
                        break
                    case 'login':
                        // console.log('login')
                        if (sessionStorage.registeredDetail !== 'true') {
                            this.$refs.myLogin.classList.add('backgroundStyle')
                            this.env === 'localhost' ? this.path = this.base + ':' + this.frontPort + this.baseUrl + '/login' : this.path = this.base + this.baseUrl + '/login'
                            window.location.href = this.path
                            return
                        } else {
                            // 是登陆状态的时候进后台
                            this.env === 'localhost' ? this.path = this.base + ':' + this.frontPort + this.baseUrl + '/myAccount' : this.path = this.base + this.baseUrl + '/myAccount'
                            window.location.href = this.path
                        }
                        break
                    default:
                }
            },
            backIndexHtml () {
                let eleItems = document.querySelector('.backgroundStyle')
                if (eleItems) {
                    eleItems.classList.remove('backgroundStyle')
                }
                this.$store.state.borderStyle = null
                localStorage.setItem('clickState', null)
                // if (sessionStorage.registeredDetail === 'true') {
                //     this.env === 'localhost' ? this.path = this.base + ':' + this.frontPort + this.baseUrl + '/myprojects/list' : this.path = this.base + this.baseUrl + '/myprojects/list'
                //     window.location.href = this.path
                // } else {
                this.$router.push({ name: 'newIndex' })
                // }
            },
            inputSearch () {
                // console.log('foucs')
                this.imgSearch = 'position: absolute;left: 114px;top: 6px;transition:.6s;'
            },
            inputSearchBlur () {
                if (!this.inputContent) {
                    this.imgSearch = 'position: absolute;left: 10px;top: 6px;transition:.4s;'
                    return
                }
                // console.log('blur')
                this.imgSearch = 'position: absolute;left: 114px;top: 6px;'
            },
            inputSearchClick (e) {
                // console.log('click')
                if (this.inputContent) {
                    // console.log('submit')
                }
                e.currentTarget.previousElementSibling.focus()
                this.imgSearch = 'position: absolute;left: 114px;top: 6px;transition:.6s;'
            },
            registeredDetailFunc () {
                // 这是'讨论'的url
                let protocol = window.location.protocol
                let env = window.location.hostname.split('.')[0]
                let forumPort = env === 'localhost' ? '4567' : '80'
                if (protocol === 'https:') {
                    forumPort = '443'
                }
                env = window.location.hostname
                let eleItems = document.querySelectorAll('.developerAllHide')
                this.forumUrl = protocol + '//' + env + ':' + forumPort + '/forum/'
                if (sessionStorage.registeredDetail === 'true' && localStorage.token !== 'null' && localStorage.token) {
                    this.isShowSelect = true
                    this.loginOut = this.$t('loginUser')
                } else {
                    this.isShowSelect = false
                    this.loginOut = this.$t('login')
                }
                for (let i = 0; i < eleItems.length; i++) {
                    if (eleItems[i].innerHTML === this.$t('file') || eleItems[i].innerHTML === this.$t('discuss')) {
                        eleItems[i].classList.remove('developerAllHide')
                        eleItems[i].classList.add('developerAllShowFlag')
                    }
                }
            }
        },
        computed: {
            borderStyle () {
                // 这是再判断能否进行 dom操作
                if (this.$refs.myLogin === undefined) {
                    setTimeout(() => {
                        if (this.$refs.myLogin !== undefined) {
                            this.styleFunc(this.$store.state.borderStyle)
                            return
                        }
                    }, 10)
                } else {
                    this.styleFunc(this.$store.state.borderStyle)
                }
                return this.$store.state.borderStyle
            },
            registeredDetail () {
                this.registeredDetailFunc()
                return this.$store.state.registeredDetail
            }
        },
        mounted () {
            this.registeredDetailFunc()
            // if (sessionStorage.registeredDetail === 'true') {
            //     this.isShowSelect = true
            // } else {
            //     this.isShowSelect = false
            // }
        }
    }
</script>
<style scoped>
.backIndexImage{
    display: inline-block;
    margin-top: 16px;
}
.imageDiv{
    cursor: pointer;
    height: 62px;
}
.developerPlan{
    /* width: 130px!important; */
    padding: 0px 36px;
}
.backgroundStyle{
    /* background-color: rgba(0, 181, 226, 0.1); */
    border-bottom: solid 2px #00b5e2;
}
.headerNavImageClass{
    padding-left: 100px;
    /* margin-top: 16px; */
    display: flex;
    flex-grow: 1;
}
.rectangle_10 {
  width: 100%;
  height: 8px;
  background-image: linear-gradient(to top, rgba(51, 51, 51, 0), rgba(51, 51, 51, 0.1));
  position: absolute;
  bottom: 0;
}
.searchInputClass{
  width: 154px;
  height: 38px;
  border-radius: 19.5px;
  border: solid 1.5px rgba(51, 51, 51, 0.5);
  /* border: none; */
  outline: none;
  font-size: 14px;
  padding-left: 16px;
  padding-right: 40px;
  color: #333333;
}
.developerAll{ 
    /* width: 96px; */
    height: 62px;
    margin-left: 4px;
    margin-right: -2px;
    cursor: pointer;
  /* background-color: rgba(0, 181, 226, 0.1); */
    padding: 0px 36px;
    font-size: 16px!important;
    height: 60px;
}
.developerAllShow:hover{
    /* background-color: rgba(0, 181, 226, 0.3); */
      color: rgba(51, 51, 51, 0.5);
      padding-top: 20px;

}
.developerAllShowFlag:hover{
    /* background-color: rgba(0, 181, 226, 0.3); */
      color: rgba(51, 51, 51, 0.5);
      padding-top: 20px;
      font-weight: 500!important;
      /* font-weight:blod; */
      /* text-shadow: 1px 0 0 currentColor; */

}
.developerAllHide:hover{cursor:not-allowed;}
.developerAllHide{
    color: rgba(51, 51, 51, 0.4)!important;
    font-weight: 300!important;
    padding: 0px 36px;
}
.serchImageClass{
    width: 28px;
    height: 28px;
    position: absolute;
    left: 10px;
    top: 6px;
    cursor: pointer;
}
.divSearchImage{
    position: relative;
    /* margin-right: 84px; */
    /* margin-left: 44px; */
    /* margin-left: 10px; */
    bottom: 4px;
    margin-top: 17px;
    padding-right: 100px; 
    display: none;
}
.headerNavClass{
    -webkit-user-select: none;
    user-select: none;
    /* padding: 15px 0px 13px 0px; */
    height: 68px;
    position: relative;
    display: flex;
}
.distribute{
  width: 140.6px;
  box-sizing:border-box;
  /* height: 29px; */
  opacity: 0.8;
  font-family: sans-serif;
  font-size: 20px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  /* line-height: 62px; */
  letter-spacing: 1.1px;
  text-align: center;
  color: #333333;
  /* color: var(--black); */
  padding-top: 22px;
}
.distribute:hover{
    font-weight: 500;
}
.documentation {
  width: 106.6px;
  box-sizing:border-box;
  /* height: 29px; */
  opacity: 0.8;
  font-family: sans-serif;
  font-size: 20px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  /* line-height: 62px; */
  padding-top: 22px;
  letter-spacing: 1.1px;
  text-align: center;
  color: #333333;
  /* color: var(--black); */
}
.support {
  width: 131.2px;
  box-sizing:border-box;
  opacity: 0.8;
  font-family: sans-serif;
  font-size: 20px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.1px;
  text-align: center;
  color: #333333;
  /* line-height: 62px; */
   padding-top: 22px;
  /* color: var(--black); */
}
.blog {
  /* width: 106.2px; */
  box-sizing:border-box;
  opacity: 0.8;
  font-family: sans-serif;
  font-size: 20px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.1px;
  text-align: center;
  color: #333333;
  /* line-height: 62px; */
  padding-top: 22px;
  /* color: var(--black); */
}
.account {
  width: 72px;
  box-sizing:border-box;
  /* height: 29px; */
  opacity: 0.8;
  font-family: sans-serif;
  font-size: 20px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.1px;
  text-align: center;
  color: #333333;
  /* line-height: 62px; */
  /* color: var(--black); */
  /* position: relative; */
  padding: 0px 14px;
  /* margin-left: 129px; */
  padding-top: 22px;
  margin-right: 75px;
  /* padding-right: 0px; */
}
.account:hover{
    font-weight: 500;
}
.spanBorderClass{
  width: 0px;
  height: 33px;
  font-family: sans-serif;
  font-size: 22px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 62px;
  letter-spacing: 1.2px;
  color: rgba(51, 51, 51, 0.3);
  /* padding: 0px 24px; */
}
/* 新增 */
.documentation:hover {
    font-weight: 500;
}
.support:hover {
    font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// HeaderIndex.vue?2fe9da80